import { of } from 'rxjs';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { combineEpics, ofType } from 'redux-observable';
import _ from 'lodash';

import { TdAjax } from 'app/lib/tdAjax';

import {
  FETCH_EXTERNAL_GROUP_RELATIONS,
  fetchExternalGroupRelationsSuccess,
  fetchExternalGroupRelationsFailure,
  DELETE_EXTERNAL_GROUP_RELATION,
  deleteExternalGroupRelationSuccess,
  deleteExternalGroupRelationFailure,
  UPDATE_EXTERNAL_GROUP_RELATION,
  updateExternalGroupRelationSuccess,
  updateExternalGroupRelationFailure,
  CREATE_EXTERNAL_GROUP_RELATION,
  createExternalGroupRelationSuccess,
  createExternalGroupRelationFailure,
  FETCH_GROUPS,
  fetchGroupsSuccess,
  fetchGroupsFailure,
  IMPORT_EXTERNAL_GROUP_RELATION,
  importExternalGroupRelationSuccess,
  importExternalGroupRelationFailure
} from './actions';

const fetchExternalGroupRelationsEpic = action$ =>
  action$.pipe(
    ofType(FETCH_EXTERNAL_GROUP_RELATIONS),
    mergeMap(action =>
      TdAjax.get('/external_group_relations/search', action.payload)),
        map(response => fetchExternalGroupRelationsSuccess(response)),
        catchError(error => of(fetchExternalGroupRelationsFailure([error]))));


const createExternalGroupRelationEpic = action$ =>
  action$.pipe(
    ofType(CREATE_EXTERNAL_GROUP_RELATION),
    mergeMap(action =>
      TdAjax.post('/external_group_relations', action.payload)),
        map(response => {
          const errors = response.response.errors;
          if (errors && !_.isEmpty(errors)) {
            return createExternalGroupRelationFailure(errors);
          }
          return createExternalGroupRelationSuccess(response);
        }),
        catchError(error => of(createExternalGroupRelationFailure([error]))));

const updateExternalGroupRelationEpic = action$ =>
  action$.pipe(
    ofType(UPDATE_EXTERNAL_GROUP_RELATION),
    mergeMap(action =>
      TdAjax.put(`/external_group_relations/${action.payload.id}`, action.payload)),
        map(response => {
          const errors = response.response.errors;
          if (errors && !_.isEmpty(errors)) {
            return updateExternalGroupRelationFailure(errors);
          }
          return updateExternalGroupRelationSuccess(response);
        }),
        catchError(error => of(updateExternalGroupRelationFailure([error]))));

const deleteExternalGroupRelationEpic = action$ =>
  action$.pipe(
    ofType(DELETE_EXTERNAL_GROUP_RELATION),
    mergeMap(action =>
      TdAjax.delete(`/external_group_relations/${action.payload}`)),
        map(response => deleteExternalGroupRelationSuccess(response)),
        catchError(error => of(deleteExternalGroupRelationFailure([error]))));

const fetchGroupsEpic = action$ =>
  action$.pipe(
    ofType(FETCH_GROUPS),
    mergeMap(action =>
      TdAjax.get('/groups', action.payload)),
        map(response => fetchGroupsSuccess(response)),
        catchError(error => of(fetchGroupsFailure([error]))));

const importExternalGroupRelationEpic = action$ =>
  action$.pipe(
    ofType(IMPORT_EXTERNAL_GROUP_RELATION),
    mergeMap(action =>
      TdAjax.upload('/external_group_relations/import', action.payload)),
        map(response => {
          const errors = response.response.errors;
          if (errors && !_.isEmpty(errors)) {
            return importExternalGroupRelationFailure(errors);
          }
          return importExternalGroupRelationSuccess(response);
        }),
        catchError(error => of(importExternalGroupRelationFailure([error]))));

export {
  fetchExternalGroupRelationsEpic,
  deleteExternalGroupRelationEpic,
  updateExternalGroupRelationEpic,
  createExternalGroupRelationEpic,
  fetchGroupsEpic,
  importExternalGroupRelationEpic
};

export default combineEpics(
  fetchExternalGroupRelationsEpic,
  deleteExternalGroupRelationEpic,
  updateExternalGroupRelationEpic,
  createExternalGroupRelationEpic,
  fetchGroupsEpic
);
